import { Component, Input, OnInit } from '@angular/core';
import { NzMarks } from 'ng-zorro-antd/slider';
import { ChoiceQuestion } from '@interfaces/questions';

@Component({
	selector: 'workflow-slider-value',
	templateUrl: './slider-value.component.html',
	styleUrls: ['./slider-value.component.scss']
})
export class SliderValueComponent implements OnInit {

	@Input() question: any;
	@Input() sliderMarks: ChoiceQuestion;
	markers: NzMarks;

	constructor() {}

	ngOnInit(): void {
		this.createMarks();
	}

	getSliderValue(index: number): number {
		return this.sliderMarks.choices[index].value as number;
	}

	createMarks(): void {
		const marks: NzMarks = {};
		let i = 0;
		this.sliderMarks.choices.forEach(choice => {
			marks[i] = choice.text;
			i++;
		})
		this.markers = marks;
	}
}
